import { Injectable, inject } from '@angular/core';

// Services
import { AppFunctionalitiesService } from './app-functionalities/app-functionalities.service';
import { ConfigService } from './config/config.service';
import { ActivationCodeService } from './activation-code/activation-code.service';
import { TrialService } from './trial/trial.service';

@Injectable()
export class ApiService {
  appFunctionalities = inject(AppFunctionalitiesService);
  activationCode = inject(ActivationCodeService);
  trial = inject(TrialService);
  config = inject(ConfigService);
}
